import { Check, X } from "lucide-react";
import { cn } from "../lib/cn";

type ActiveToggleProps = {
  checked: boolean;
  disabled?: boolean;
  onChange: () => void;
  label: string;
};

/** Direkter Statuswechsel; das Symbol fährt sichtbar mit dem Schalter mit. */
export function ActiveToggle({ checked, disabled = false, onChange, label }: ActiveToggleProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={`${label} ${checked ? "deaktivieren" : "aktivieren"}`}
      title={`${label} ${checked ? "deaktivieren" : "aktivieren"}`}
      disabled={disabled}
      onClick={onChange}
      className={cn(
        "relative inline-flex h-6 w-11 shrink-0 items-center rounded-full border transition-colors duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
        checked
          ? "border-emerald-600 bg-emerald-500 hover:bg-emerald-600"
          : "border-slate-300 bg-slate-200 hover:bg-slate-300"
      )}
    >
      <span
        aria-hidden="true"
        className={cn(
          "inline-flex h-5 w-5 items-center justify-center rounded-full bg-white shadow-sm transition-transform duration-150",
          checked ? "translate-x-5 text-emerald-600" : "translate-x-0.5 text-slate-500"
        )}
      >
        {checked ? <Check size={12} strokeWidth={3} /> : <X size={12} strokeWidth={3} />}
      </span>
    </button>
  );
}
